import JobOfferingDto from '../model/jobOfferingDto';

const FEED_URL =
  'https://phatconsulting.onapply.de/feed/render.html?format=json';
const ONAPPLY_ORIGIN = 'https://phatconsulting.onapply.de/';

type OnapplyListing = {
  name?: unknown;
  city?: unknown;
  linkJobAd?: unknown;
  employmentTypes?: { 'name_de-DE'?: unknown }[];
};

const asText = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : '';

// The feed is external data: only accept job ad links on our own onapply career site.
export const toJobOfferings = (feed: unknown): JobOfferingDto[] => {
  const listings = (feed as { listings?: unknown })?.listings;

  if (!Array.isArray(listings)) return [];

  return (listings as OnapplyListing[]).flatMap((listing) => {
    const title = asText(listing.name);
    const jobAdUrl = asText(listing.linkJobAd);

    if (!title || !jobAdUrl.startsWith(ONAPPLY_ORIGIN)) return [];

    const employmentTypes = Array.isArray(listing.employmentTypes)
      ? listing.employmentTypes.map((type) => asText(type?.['name_de-DE']))
      : [];

    return [
      {
        OfferingId: jobAdUrl,
        Title: title,
        // "Hamburg, Deutschland" -> "Hamburg": the card label stays short like on phatconsulting.de
        ShortDescription: [asText(listing.city).split(',')[0].trim(), ...employmentTypes]
          .filter(Boolean)
          .join(' · '),
        JobAdUrl: jobAdUrl,
      },
    ];
  });
};

const fetchJobOfferings = async (): Promise<JobOfferingDto[]> => {
  const response = await fetch(FEED_URL, { cache: 'no-store' });

  if (!response.ok) throw new Error(`onapply feed: HTTP ${response.status}`);

  return toJobOfferings(await response.json());
};

export default fetchJobOfferings;
